<template>
  <div>
    <div v-if="showLoading" class="showLoading">
      <img src="@/assets/imgs/loading.gif" alt="" width="300" height="210">
    </div>
    <div v-else>
      <VedioTitle></VedioTitle>
      <VideoList :videoData = 'videoData' ref="videoList"></VideoList>
      <Model :showModel="showModel"></Model>
      <BackTop></BackTop>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import VedioTitle from "./vediochild/VideoTitle.vue";
import VideoList from "./vediochild/VideoList.vue";

import Model from "@/components/common/model/Model.vue";
import Footer from "@/components/common/layout/Footer.vue";
import BackTop from "@/components/common/backtop/BackTop.vue";
import { getVideos } from "@/network/details.js";

export default {
  name: "Vedio",
  components: {
    VedioTitle,
    VideoList,
    Model,
    Footer,
    BackTop,
  },
  data() {
    return {
      showModel: false,
      page: 1,
      videoData: [],
      loading: true,
      showLoading: true,
    };
  },
  mounted() {
    document.title = "Video | ShanghaiEye";
    this.getVideoFn();
    document.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    document.removeEventListener("scroll", this.loadMore);
  },
  methods: {
    //获取视频列表
    getVideoFn() {
      getVideos({ page: this.page, size: 12 })
        .then(res => {
          this.videoData = this.videoData.concat(res.data);
          this.loading = true;
          this.showLoading = false;
        })
        .catch(res => {
          this.loading = true;
        });
    },
    //滚动到底部加载更多
    load() {
      if (this.loading) {
        this.loading = false;
        setTimeout(() => {
          this.page++;
          this.getVideoFn();
          this.$refs.videoList.handelWidth();
        }, 500);
      }
    },
    //触发滚动
    loadMore() {
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; //document的滚动高度
      let nowScotop =
        document.documentElement.clientHeight || document.body.clientHeight; //可视区高度
      let wheight =
        document.documentElement.scrollTop || document.body.scrollTop; //已滚动高度

      if (this.loading) {
        if (nowScotop >= scrollHeight - wheight - 5) {
          setTimeout(() => {
            this.load(); //加载列表的请求方法
          }, 500);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.vedio {
  .title {
    width: 100%;
    font-size: 0.7rem;
    font-family: FranklinGothic-Demi;
    color: #333333;
    font-weight: bolder;
  }
}
</style>